import React, { Component } from "react";
import { arrayOf, bool, func, shape, string } from "prop-types";

import RadioButton from "pages/_components/fields/Radio";
import classNames from "classnames";

class RadioButtonGroup extends Component {
    static propTypes = {
        inLineControl: bool,
        labelKey: string,
        name: string.isRequired,
        onChange: func.isRequired,
        options: arrayOf(shape({})).isRequired,
        value: string,
        valueKey: string,
        selectorId: string,
        className: string,
        disabled: bool,
    };

    static defaultProps = {
        labelKey: "label",
        inLineControl: false,
        value: "",
        valueKey: "id",
        selectorId: "",
        disabled: false,
    };

    handleRadioChange = (event) => {
        const { onChange } = this.props;
        onChange(event.target.value);
    };

    render() {
        const { inLineControl, labelKey, name, options, selectorId, value, valueKey, className, disabled } = this.props;

        return (
            <div className={classNames(className, "form-group-control-list")}>
                {options.map((option) => (
                    <RadioButton
                        id={`${selectorId}_${option[valueKey]}`}
                        checked={option[valueKey] === value}
                        inLineControl={inLineControl}
                        key={`${selectorId}_${option[valueKey]}`}
                        label={option[labelKey]}
                        name={name}
                        onChange={this.handleRadioChange}
                        value={option[valueKey]}
                        disabled={disabled}
                    />
                ))}
            </div>
        );
    }
}

export default RadioButtonGroup;
